export interface NavLink {
  id: string;
  label: string;
}

export const navLinks: NavLink[] = [
  { id: 'today', label: '今日更新' },
  { id: 'new-release', label: '新片上映' },
  { id: 'cinema', label: '院线同步' },
  { id: 'hot', label: '热播大片' },
  { id: 'library', label: '片库筛选' },
  { id: 'news', label: '影讯速递' },
  { id: 'guide', label: '观影指南' },
  { id: 'faq', label: '常见问题' },
];

export interface HeroStat {
  value: string;
  label: string;
}

export const heroStats: HeroStat[] = [
  { value: '1,280+', label: '在库影片' },
  { value: '36', label: '覆盖类型' },
  { value: '每日', label: '更新节奏' },
  { value: '4K', label: '清晰度支持' },
];

export interface NewsArticle {
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  excerpt: string;
  image: string;
}

export const newsArticles: NewsArticle[] = [
  {
    id: 'news-1',
    title: '2024 新片梯队渐次就位：题材分布更均衡',
    category: '片单观察',
    date: '10 月 06 日',
    readTime: '5 分钟',
    excerpt: '从目前公布的 2024 新片名单来看，科幻、剧情与动画三条线并行推进，中小成本现实题材的数量也较往年明显增加，观众可选择的类型比过去更宽。',
    image: 'https://readdy.ai/api/search-image?query=cinema%20hall%20with%20row%20of%20empty%20red%20velvet%20seats%20and%20warm%20projector%20light%20beams%2C%20cinematic%20atmosphere%2C%20warm%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=640&height=420&seq=news-01&orientation=landscape',
  },
  {
    id: 'news-2',
    title: '院线同步是什么意思？排片与密钥的关系',
    category: '基础知识',
    date: '10 月 04 日',
    readTime: '4 分钟',
    excerpt: '「院线同步」通常指影院上映与线上可看时间的安排关系。它受排片、密钥下发与发行窗口影响，因此同一部影片在不同城市的可看时间也可能存在差异。',
    image: 'https://readdy.ai/api/search-image?query=modern%20cinema%20lobby%20with%20glowing%20poster%20light%20boxes%20and%20marquee%20sign%2C%20warm%20evening%20light%2C%20inviting%20atmosphere%2C%20warm%20amber%20tones%2C%20no%20text&width=640&height=420&seq=news-02&orientation=landscape',
  },
  {
    id: 'news-3',
    title: '热播大片榜单是怎么排的：四个常用维度',
    category: '选片方法',
    date: '10 月 02 日',
    readTime: '6 分钟',
    excerpt: '播放量、讨论度、评分与完播率是常见的热播参考维度。单看其中一项容易偏颇，综合观察更能判断一部影片是否适合自己，本页榜单也据此做了一般性整理。',
    image: 'https://readdy.ai/api/search-image?query=analytics%20dashboard%20on%20a%20dark%20monitor%20screen%20with%20glowing%20orange%20charts%20and%20bars%2C%20cinema%20data%20theme%2C%20warm%20amber%20accents%2C%20no%20text&width=640&height=420&seq=news-03&orientation=landscape',
  },
  {
    id: 'news-4',
    title: '在家观影的音画设置：三个容易忽略的细节',
    category: '观影技巧',
    date: '09 月 29 日',
    readTime: '5 分钟',
    excerpt: '除了分辨率，画面比例、字幕描边与声音动态范围同样影响观感。花几分钟做基础设置，往往比单纯提升清晰度更能改善一次完整的观影体验。',
    image: 'https://readdy.ai/api/search-image?query=cozy%20dark%20living%20room%20with%20a%20large%20tv%20glowing%20on%20a%20wall%2C%20soft%20ambient%20warm%20light%2C%20blanket%20and%20popcorn%20on%20a%20table%2C%20warm%20tones%2C%20no%20text&width=640&height=420&seq=news-04&orientation=landscape',
  },
];

export interface GuideStep {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

export const watchGuides: GuideStep[] = [
  {
    id: 'guide-1',
    icon: 'ri-calendar-check-line',
    title: '先看今日更新',
    desc: '每天想快速知道有什么可看，从「今日更新」入手最省时间。这里汇总当天的上架与新情报，条目少而精，几分钟就能扫完。',
  },
  {
    id: 'guide-2',
    icon: 'ri-movie-2-line',
    title: '再按上映阶段筛选',
    desc: '想追新片就进「新片上映」，想看已上映的口碑片就进「热播大片」，想在影院同步档期附近关注动态则看「院线同步」。',
  },
  {
    id: 'guide-3',
    icon: 'ri-filter-3-line',
    title: '用类型标签缩小范围',
    desc: '在「片库筛选」里按科幻、悬疑、剧情等标签切换，还能输入关键词搜索片名或简介，筛选只作用于本页已有的影片，结果即时呈现。',
  },
  {
    id: 'guide-4',
    icon: 'ri-book-open-line',
    title: '补一点基础常识',
    desc: '排片、密钥、发行窗口这些词常出现在选片讨论里。看看「影讯速递」与「常见问题」，有助于判断一部影片的可看时间与适合人群。',
  },
];

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: 'faq-1',
    question: '星辰影院这个页面主要提供什么内容？',
    answer: '本页围绕「星辰影院最新电影」这一主题，集中整理今日更新、新片上映、院线同步、热播大片与 2024 新片等信息，方便在一页之内完成找片、了解与筛选，不必在多个页面之间来回跳转。',
  },
  {
    id: 'faq-2',
    question: '「今日更新」多久刷新一次？',
    answer: '今日更新按天滚动整理。由于片源与排片安排会变化，具体条目以当天页面展示为准；本页内容为一般性整理，不构成对具体影片上架时间的承诺。',
  },
  {
    id: 'faq-3',
    question: '院线同步和线上可看是一回事吗？',
    answer: '不是同一概念。院线同步更多描述影院上映与后续线上可看时间之间的安排关系，会受排片、密钥与发行窗口影响。同一部影片在不同地区、不同影院的可看时间也可能不同。',
  },
  {
    id: 'faq-4',
    question: '片库筛选里的搜索能查到所有影片吗？',
    answer: '搜索与标签筛选仅作用于本页已经展示的影片条目，属于本页内容的本地筛选，不会访问外部数据。筛选结果会随输入即时更新，清空关键词即可恢复完整列表。',
  },
  {
    id: 'faq-5',
    question: '榜单里的评分代表什么？',
    answer: '评分与热度是用于帮助比较的一般性参考值，来自综合整理的展示口径，用于呈现影片之间的相对位置，并非对影片质量的权威结论，选择时建议结合类型与简介判断。',
  },
  {
    id: 'faq-6',
    question: '手机上浏览会不会很难读？',
    answer: '页面针对移动端做了适配：卡片会从多列收拢为单列，文字与间距按屏幕缩放，标签与按钮支持点击与键盘操作，密集信息在手机上也会保持可读。',
  },
];